export default {
  data () {
    return {
      loaderColor: `loader-component--${this.color}`,
      loaderSize: `loader-component--${this.size}`,
    }
  },
}


// WEBPACK FOOTER //
// ./src/components/LoaderMixin.js